package uk.co.nickthecoder.kyd

import uk.co.nickthecoder.kyd.util.Vector2
import kotlin.math.round

interface Snapping {
    fun snap(worldPoint: Vector2): Vector2
}

object NoSnapping : Snapping {
    override fun snap(worldPoint: Vector2) = worldPoint
}

class GridSnapping(val sizeX: Float, val sizeY: Float) : Snapping {

    constructor(size: Float) : this(size, size)

    override fun snap(worldPoint: Vector2) = Vector2(
        round(worldPoint.x.div(sizeX)) * sizeX,
        round(worldPoint.y.div(sizeY)) * sizeY
    )

}
